import React from 'react';
import { BrowserRouter as Router, Link } from "react-router-dom";

import './NavBar.css';

class NavBar extends React.Component {

  render() {
    return (
      <Router>
        <nav className="navbar">
          <div className="navbar-image"></div>
          <div className="navbar-links" id="myNavbar">
            <Link className="navbar-a icon" to="#" onClick={this.myFunction}>
              <i className="fa fa-bars"></i>
            </Link>
            <Link className="navbar-a" to="/" onClick={(event) => this.clickLink(event, 0)}>home</Link>
            <Link className="navbar-a" to="/band" onClick={(event) => this.clickLink(event, 1)}>band</Link>
            <Link className="navbar-a" to="/blog" onClick={(event) => this.clickLink(event, 2)}>blog</Link>
            <Link className="navbar-a" to="/music" onClick={(event) => this.clickLink(event, 3)}>musik</Link>
            <Link className="navbar-a" to="/contact" onClick={(event) => this.clickLink(event, 4)}>kontakt</Link>
          </div>
        </nav>
      </Router>
    )
  }

  clickLink(event, index) {
    this.props.handler(event, index);
    this.reset();
  }

  reset() {
    var x = document.getElementById("myNavbar");
    if (x.className === "navbar-links responsive") {
      x.className = "navbar-links";
    }
  }

  myFunction() {
    var x = document.getElementById("myNavbar");

    if (x.className === "navbar-links") {
        x.className += " responsive";
    } else {
        x.className = "navbar-links";
    }
  }
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/navBar/NavBar.js